import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const discoveryCardStyles = {
  smartCardTexture: (): SystemStyleObject<Theme> => ({
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/grid.png)`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    mx: "auto",

    pb: "50%", // aspect-ratio 2/1
    maxWidth: "100%",
  }),
  sneakers: (theme: Theme): SystemStyleObject<Theme> => ({
    zIndex: 10,
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    height: "auto",
    filter: {
      lg: `drop-shadow(0px 0px 78px ${theme.palette.background.default})`,
    },
    fontSize: 0,
  }),
  border: (theme: Theme): SystemStyleObject<Theme> => ({
    zIndex: 10,
    position: "absolute",
    transform: "translate(-50%, -50%)",
    objectFit: "contain",
    top: "50%",
    left: "50%",
    height: "auto",
    filter: {
      lg: `drop-shadow(0px 0px 20px ${theme.palette.background.default}) drop-shadow(0px 0px 23px ${theme.palette.secondary.main})`,
    },
  }),
  cube: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "22%",
    left: "28%",
    width: "28%",
    filter: {
      lg: `drop-shadow(0px 0px 20px ${theme.palette.background.default})`,
    },
  }),
  cart: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "16%",
    left: "55%",
    width: "43%",
    filter: {
      lg: `drop-shadow(0px 0px 20px ${theme.palette.background.default})`,
    },
  }),
  nfc: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "65%",
    left: "25%",
    width: "30%",
    filter: {
      lg: `drop-shadow(0px 0px 20px ${theme.palette.background.default})`,
    },
  }),
  nft: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "53%",
    left: "67%",
    width: "23%",
    filter: {
      lg: `drop-shadow(0px 0px 20px ${theme.palette.background.default})`,
    },
  }),
};

export default discoveryCardStyles;
